import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../../services/main/api.service';
import { LoginService } from '../../../../services/authentication/login.service';
import { NgbModal, ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Storage } from '@ionic/storage';
import { Router, ActivatedRoute } from '@angular/router';
import { Global } from '../../../../services/global';
import { BaseCrudComponent } from '../../../base-crud/base-crud.component';
import { TranslateService } from '@ngx-translate/core';
import { Observable, BehaviorSubject, of, throwError, from, concat } from 'rxjs';
import { mergeMap, catchError, timeout, retry } from 'rxjs/operators';
import { ExportAsService, ExportAsConfig } from 'ngx-export-as';
import * as moment from 'moment-timezone';

import { LazyLoadEvent } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import {MessageService} from 'primeng/api';

@Component({
  selector: 'app-kpistoptime',
  templateUrl: './kpistoptime.component.html',
  styleUrls: ['./kpistoptime.component.css']
})
export class KpistoptimeComponent extends BaseCrudComponent {

  	@ViewChild('myCanvas', {static: false}) myCanvas: ElementRef;

  	exportAsConfig: ExportAsConfig = {
        type: 'xlsx',
        elementIdOrContent: 'exportable'
    };

  	translations:any;
	header:any;
	theaders:any;
	momentjs: any = moment;
    curr_date:any;
    today:any;
    dstart:any;
    dend:any;
    
    totals:any;
    frozenCols:any;
    loadingRequired = false;

    //filters data
    dropdowns:any;
    sr_filter:any;
    hr_filter:any;
    driver_filter:any;
    ds_filter:any;
    rs_filter:any;

    sel_delivery:any;
    summary_1:any;

    // Bars
  	public barChartLabels: string[] = ['Total'];
  	
  	public barChartData: any = [
  		{data:[], label:''}
  	];

  	public barChartOptions: any = {
	    scaleShowVerticalLines: false,
	    responsive: true,
	    barThickness: 10,
	    scales: {
            yAxes: [{
                ticks:{
                    callback:(v)=>this.formatY(v)/*,
                    stepSize:300, //add a tick every 5 minutes*/
                }
            }]
        },
        tooltips: {
            callbacks: {
                label:(tooltipItem, data)=> this.formatLabelY(tooltipItem, data)
            }
        }
	};

    public branches:any;
    public SubsidiaryId:any;
    public usr_subsidiary:any;

	constructor(
	    srv: ApiService,
	    modalService: NgbModal,
	    storage: Storage,
  		router: Router,
  		private route: ActivatedRoute,
        public translate: TranslateService,
        private exportAsService: ExportAsService,
        private login: LoginService
	  ) {
	    super(srv, modalService, storage, router);
	    this.read_url = 'LogisticKpis/Downtime';
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.dropdowns = [];
        this.barChartData = null;

        this.summary_1 = [];

        this.frozenCols = [
            //{ field: 'guideNumber', header: 'Guia', sortable:true, sortfield:'', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input'}
        ];

        this.theaders = [
        	{ field: 'driver', header: 'Conductor', sortable:true, sortfield:'driver', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', filter:'input', chart:false},
            { field: 'groupDriver', header: 'Grupo', sortable:true, sortfield:'groupDriver', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'routeDate', header: 'Fecha', sortable:true, sortfield:'routeDate', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'routeName', header: 'Ruta Hivi', sortable:true, sortfield:'routeName', styleC:{'text-align':'center'}, width:{'width.px': 180}, isColor:false, pre:'', pos:'', total:'', chart:false},
            { field: 'downTime', header: 'Total tiempo parada', sortable:true, sortfield:'downTime', styleC:{'text-align':'center'}, width:{'width.px': 150}, isColor:false, pre:'', pos:'', total:'', chart:false}
        ];

        this.branches = [];
        this.SubsidiaryId = null;
        this.usr_subsidiary = -1;
    }

    ngOnInit() {
        this.clearFilters();

    	this.translate.getTranslation(this.translate.currentLang)
        .subscribe((translations) => {
            this.translations = translations;
            super.ngOnInit();

            this.getBranchesData().subscribe(b => {
                this.loadingRequired = false;
                if( b != false ){
                    this.branches = b;
                }
            });

            this.login.getTeam().then(t => {
                if( (t == undefined) || (t == null) ){
                    t = 0;
                }
                
                this.usr_subsidiary = t;
            });
        });
    }

    clearData(){
        this.header = {};
        this.rows = [];
        this.totals = [];
        this.summary_1 = [];
    }

    public getList(){
        var qst = this.read_url;
        var obj:any;
        //this.f_datefrom = '2020-09-01';
        this.clearData();

        obj = {
            Start: this.f_datefrom,
            End: this.f_dateto,
            SubsidiaryId: (this.SubsidiaryId == 0) ? null : this.SubsidiaryId
        }

        this.loadingList = true;
        //console.log(obj);

        this.srv.postCall(qst, obj).subscribe(x => {
        	this.loadingList = false;

            if(x.status){
                var rs = x.data;

                this.summary_1 = rs.summary1;

                this.barChartData = [];
                this.barChartLabels = ['Total'];

                //set bar chart labels
                if( Array.isArray(this.summary_1['detail']) ){
                	//let tmp = [];
                    let tmp:any;

                	this.summary_1['detail'].forEach(x => {
                		tmp = {data:[], label:x['driver']};
                		let vals = x.downTime.split(':');
                        //console.log(vals);
                        let duration = this.momentjs.duration({hours:vals[0], minutes:vals[1], seconds:vals[2]});
                        //console.log(duration.asSeconds());
	                	//tmp.data.push(x.downTime);
                        tmp.data.push(duration.asSeconds());
	                	this.barChartData.push(tmp);
                	});

                	//this.barChartData = [{data: tmp, label: 'My Data'}];

                	//hack to start y from 0
                	//this.barChartData.push({data:[0], label:''});
                }

                this.rows = rs.details;
            }
        });
    }

    public clearFilters(){
    	this.sr_filter = '';
	    this.hr_filter = '';
	    this.driver_filter = '';
	    this.ds_filter = '';
	    this.rs_filter = '';

	    let today = this.momentjs().tz('America/Guayaquil').format('YYYY-MM-DD');
        this.f_datefrom = today;
        this.f_dateto = today;
    }

    exportReport(){
        this.exportAsService.save(this.exportAsConfig, 'kpi_stop_time').subscribe(() => {
          // save started
        });
    }

    public getBranchesData(){
        var par_url = 'Subsidiary/All';
        return this.srv.getCall(par_url).pipe(
                    mergeMap(x => {
                        let mydata:any = {status: false, message:'', data:[]};
                        mydata = x;
                        
                        if(mydata.status == true ){
                          return of(mydata.data);
                        }
                        else{
                          return of(false);
                        }
                      }),
                      //timeout(MAX_TIME),
                      catchError(data => of(false))
                );
    }

    public formatY(val){
        let tmp = this.momentjs.duration(val, 's');
        let str = '';

        if( tmp.years() != '' ){
            str += tmp.years() + 'a ';
        }

        if( tmp.months() != '' ){
            str += tmp.months() + 'm ';
        }

        if( tmp.days() != '' ){
            str += tmp.days() + 'd ';
        }
        
        let hours = tmp.hours() + '';
        if( hours != '' ){
            str += hours.padStart(2, '0') + ':';
        }
        else{
            str += '00:'
        }

        let minutes = tmp.minutes() + '';
        if( minutes != '' ){
            str += minutes.padStart(2, '0') + ':';
        }
        else{
            str += '00:'
        }

        let seconds = tmp.seconds() + '';
        if( seconds != '' ){
            str += seconds.padStart(2, '0');
        }
        else{
            str += '00'
        }

        return str;
        //return tmp.toISOString();
        //return new Date(val*1000).toISOString().match("T(.*).000Z")[1];
    }

    public formatLabelY(tooltipItem, data) {
        return data.datasets[tooltipItem.datasetIndex].label + ': ' + this.formatY(tooltipItem.yLabel);
    }

}
